import { render, staticRenderFns } from "./expandable-content-card.vue?vue&type=template&id=6c70f30e"
import script from "./expandable-content-card.vue?vue&type=script&lang=js"
export * from "./expandable-content-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports